// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════
   HOME PAGE STYLES
   ═══════════════════════════════════════════════════════════════ */

/* ── Page Container ──────────────────────────────────────────── */
.home-page {
    position: relative;
    min-height: 100dvh;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 2rem 1.5rem 4rem;
    background: #fafaf9;
}

.dark .home-page {
    background: hsl(228, 14%, 6%);
}


.home-container {
    position: relative;
    z-index: 1;
    max-width: 480px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 1.75rem;
}

/* ── Floating Orbs (Disabled) ────────────────────────────────── */
.home-orb {
    display: none;
}

/* ── Hero Greeting ───────────────────────────────────────────── */
.home-hero {
    text-align: center;
    padding-top: 1rem;
}

.home-greeting {
    font-size: 1.75rem;
    font-weight: 800;
    color: #111827;
    line-height: 1.2;
    margin-bottom: 0.5rem;
    letter-spacing: -0.02em;
}

.home-wave {
    display: inline-block;
    animation: home-wave-anim 2s ease-in-out infinite;
    transform-origin: 70% 70%;
}

@keyframes home-wave-anim {
    0%, 100% { transform: rotate(0deg); }
    10% { transform: rotate(14deg); }
    20% { transform: rotate(-8deg); }
    30% { transform: rotate(14deg); }
    40% { transform: rotate(-4deg); }
    50% { transform: rotate(10deg); }
    60% { transform: rotate(0deg); }
}

.home-tagline {
    font-size: 0.95rem;
    color: #6b7280;
    max-width: 320px;
    margin: 0 auto;
    line-height: 1.5;
}

/* ── Metric Cards ────────────────────────────────────────────── */
.home-metrics {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.75rem;
}

.home-metric-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 1rem;
    padding: 1rem 0.75rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.home-metric-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.home-metric-icon {
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.home-metric-pink {
    background: #fef3c7;
    color: #b45309;
}

.home-metric-orange {
    background: #ffedd5;
    color: #c2410c;
}

.home-metric-purple {
    background: #f3f4f6;
    color: #4b5563;
}

.home-metric-info {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
}

.home-metric-value {
    font-size: 1.5rem;
    font-weight: 800;
    color: #111827;
    line-height: 1;
}

.home-metric-label {
    font-size: 0.65rem;
    color: #9ca3af;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

/* ── Empty State ─────────────────────────────────────────────── */
.home-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 2rem 1.5rem;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 1.25rem;
}

.home-empty-icon {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 1rem;
    background: #fef3c7;
    color: #b45309;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
}

.home-empty-text {
    font-size: 0.9rem;
    color: #6b7280;
    line-height: 1.6;
    max-width: 300px;
}

/* ── Brand Focus Card ────────────────────────────────────────── */
.home-brand-focus {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 1.25rem;
    padding: 1rem 1.25rem;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
    text-align: left;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.home-brand-focus:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border-color: #d1d5db;
}

.home-brand-focus-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.65rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #b45309;
    background: #fef3c7;
    padding: 0.25rem 0.75rem;
    border-radius: 999px;
    margin-bottom: 0.75rem;
    width: fit-content;
}

.home-brand-focus-content {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    min-width: 0;
    overflow: hidden;
}

.home-brand-logo {
    width: 3rem;
    height: 3rem;
    border-radius: 0.75rem;
    object-fit: cover;
    flex-shrink: 0;
    background: #f3f4f6;
}

.home-brand-logo-placeholder {
    width: 3rem;
    height: 3rem;
    border-radius: 0.75rem;
    background: #d97706;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    font-weight: 700;
    flex-shrink: 0;
}

.home-brand-focus-info {
    flex: 1;
    min-width: 0;
}

.home-brand-name {
    font-size: 1rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 0.125rem;
}

.home-brand-desc {
    font-size: 0.75rem;
    color: #9ca3af;
    line-height: 1.4;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    word-break: break-word;
}

/* ── CTA Buttons ─────────────────────────────────────────────── */
.home-ctas {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.home-cta {
    display: flex;
    align-items: center;
    gap: 0.875rem;
    width: 100%;
    padding: 1rem 1.25rem;
    border-radius: 1rem;
    border: none;
    cursor: pointer;
    transition: all 0.25s ease;
    text-align: left;
}

.home-cta-primary {
    background: #d97706;
    color: white;
    box-shadow: 0 2px 10px rgba(217, 119, 6, 0.25);
}

.home-cta-primary:hover {
    background: #b45309;
    box-shadow: 0 4px 16px rgba(217, 119, 6, 0.35);
}

.home-cta-secondary {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    color: #374151;
}

.home-cta-secondary:hover {
    background: #f9fafb;
    border-color: #d1d5db;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.home-cta-ghost {
    background: transparent;
    border: 1px dashed rgba(217, 119, 6, 0.28);
    color: #6b7280;
}

.home-cta-ghost:hover {
    background: rgba(255, 255, 255, 0.5);
    border-color: rgba(217, 119, 6, 0.4);
    color: #374151;
}

.home-cta-icon {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.home-cta-primary .home-cta-icon {
    background: rgba(255, 255, 255, 0.2);
}

.home-cta-secondary .home-cta-icon,
.home-cta-ghost .home-cta-icon {
    background: #fef3c7;
    color: #b45309;
}

.home-cta-text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
}

.home-cta-label {
    font-size: 0.95rem;
    font-weight: 650;
    line-height: 1.3;
}

.home-cta-sublabel {
    font-size: 0.75rem;
    opacity: 0.7;
    line-height: 1.3;
}

/* ── Product Preview ─────────────────────────────────────────── */
.home-preview-section {
    margin-top: 0.5rem;
}

.home-preview-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
}

.home-preview-title {
    font-size: 0.8rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.home-preview-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5rem;
}

.home-preview-card {
    position: relative;
    aspect-ratio: 3 / 4;
    border-radius: 0.75rem;
    overflow: hidden;
    background: #f3f4f6;
}

.home-preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.home-preview-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.5rem;
    background: linear-gradient(to top, rgba(0,0,0,0.6), transparent);
}

.home-preview-price {
    font-size: 0.7rem;
    font-weight: 700;
    color: white;
}


/* ═══════════════════════════════════════════════════════════════
   MOBILE RESPONSIVENESS — HOME PAGE
   ═══════════════════════════════════════════════════════════════ */
@media (max-width: 767px) {
    .home-page {
        padding: 1.25rem 1rem 3rem;
    }

    .home-container {
        gap: 1.25rem;
    }

    /* ── Greeting ── */
    .home-greeting {
        font-size: 1.4rem;
    }

    .home-tagline {
        font-size: 0.85rem;
        max-width: 280px;
    }

    /* ── Metrics ── */
    .home-metrics {
        grid-template-columns: repeat(3, 1fr);
        gap: 0.5rem;
    }

    .home-metric-card {
        padding: 0.75rem 0.5rem;
        border-radius: 0.75rem;
    }

    .home-metric-icon {
        width: 2rem;
        height: 2rem;
        border-radius: 0.5rem;
    }

    .home-metric-icon svg {
        width: 1rem;
        height: 1rem;
    }

    .home-metric-value {
        font-size: 1.25rem;
    }

    .home-metric-label {
        font-size: 0.55rem;
        letter-spacing: 0.02em;
    }

    /* ── Empty State ── */
    .home-empty-state {
        padding: 1.5rem 1rem;
    }

    .home-empty-icon {
        width: 3rem;
        height: 3rem;
    }

    .home-empty-text {
        font-size: 0.82rem;
    }

    /* ── Brand Focus ── */
    .home-brand-focus {
        padding: 0.875rem 1rem;
        border-radius: 1rem;
    }

    .home-brand-logo,
    .home-brand-logo-placeholder {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 0.625rem;
    }

    .home-brand-logo-placeholder {
        font-size: 1rem;
    }

    .home-brand-name {
        font-size: 0.9rem;
    }

    .home-brand-desc {
        font-size: 0.7rem;
    }

    /* ── CTAs ── */
    .home-cta {
        padding: 0.875rem 1rem;
        gap: 0.75rem;
        border-radius: 0.875rem;
    }

    .home-cta-icon {
        width: 2.25rem;
        height: 2.25rem;
        border-radius: 0.625rem;
    }

    .home-cta-icon svg {
        width: 1.125rem;
        height: 1.125rem;
    }

    .home-cta-label {
        font-size: 0.875rem;
    }

    .home-cta-sublabel {
        font-size: 0.7rem;
    }

    /* ── Preview Grid ── */
    .home-preview-grid {
        grid-template-columns: repeat(4, 1fr);
        gap: 0.375rem;
    }

    .home-preview-card {
        border-radius: 0.5rem;
    }

    .home-preview-price {
        font-size: 0.6rem;
    }

    .home-preview-overlay {
        padding: 0.35rem;
    }

    /* ── Orbs ── */
    .home-orb-1 {
        width: 160px;
        height: 160px;
        top: -40px;
        right: -50px;
    }

    .home-orb-2 {
        width: 120px;
        height: 120px;
    }

    .home-orb-3 {
        width: 100px;
        height: 100px;
    }
}


/* ═══════════════════════════════════════════════════════════════
   TUTORIAL OVERLAY STYLES
   ═══════════════════════════════════════════════════════════════ */

/* ── Bubble ──────────────────────────────────────────────────── */
.tutorial-bubble {
    width: 320px;
    max-width: calc(100vw - 2rem);
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px) saturate(1.4);
    border: 1px solid rgba(217, 119, 6, 0.2);
    border-radius: 1.25rem;
    padding: 1.25rem;
    box-shadow:
        0 8px 32px rgba(217, 119, 6, 0.15),
        0 2px 8px rgba(0, 0, 0, 0.04);
    animation: tutorial-float 3s ease-in-out infinite;
}

@keyframes tutorial-float {
    0%, 100% { transform: translateY(-50%); }
    50% { transform: translateY(calc(-50% - 6px)); }
}

/* ── Caret ───────────────────────────────────────────────────── */
.tutorial-caret {
    position: absolute;
    width: 12px;
    height: 12px;
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(217, 119, 6, 0.2);
    transform: rotate(45deg);
}

.tutorial-caret-left {
    left: -7px;
    top: 50%;
    margin-top: -6px;
    border-right: none;
    border-top: none;
}

/* ── Close Button ────────────────────────────────────────────── */
.tutorial-close {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    border: none;
    background: #f3f4f6;
    color: #9ca3af;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
}

.tutorial-close:hover {
    background: #e5e7eb;
    color: #374151;
}

/* ── Content ─────────────────────────────────────────────────── */
.tutorial-content {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 1rem;
}

.tutorial-icon-wrapper {
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 0.625rem;
    background: #fef3c7;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.tutorial-text {
    flex: 1;
    min-width: 0;
    padding-right: 1rem;
}

.tutorial-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 0.25rem;
}

.tutorial-description {
    font-size: 0.82rem;
    color: #6b7280;
    line-height: 1.5;
}

/* ── Footer ──────────────────────────────────────────────────── */
.tutorial-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 0.75rem;
    border-top: 1px solid rgba(217, 119, 6, 0.12);
}

.tutorial-progress {
    font-size: 0.7rem;
    color: #9ca3af;
    font-weight: 500;
}

.tutorial-dots {
    display: flex;
    gap: 0.35rem;
}

.tutorial-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #e5e7eb;
    transition: all 0.3s ease;
}

.tutorial-dot-active {
    background: #d97706;
    width: 16px;
    border-radius: 3px;
}

.tutorial-next {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.8rem;
    font-weight: 600;
    color: #b45309;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    border-radius: 0.5rem;
    transition: background 0.2s;
}

.tutorial-next:hover {
    background: #fef3c7;
}

/* ═══════════════════════════════════════════════════════════════
   MOBILE RESPONSIVENESS — TUTORIAL
   ═══════════════════════════════════════════════════════════════ */
@media (max-width: 767px) {
    .tutorial-bubble {
        width: calc(100vw - 2rem);
        max-width: 360px;
        padding: 1rem;
        border-radius: 1rem;
        animation: tutorial-float-mobile 3s ease-in-out infinite;
        /* On mobile the bubble sits at the bottom, no translateY(-50%) needed */
    }

    @keyframes tutorial-float-mobile {
        0%, 100% { transform: translateX(-50%) translateY(0); }
        50% { transform: translateX(-50%) translateY(-6px); }
    }

    /* Hide caret on mobile since sidebar is not visible */
    .tutorial-caret {
        display: none;
    }

    .tutorial-icon-wrapper {
        width: 2rem;
        height: 2rem;
        border-radius: 0.5rem;
    }

    .tutorial-icon-wrapper svg {
        width: 1rem;
        height: 1rem;
    }

    .tutorial-title {
        font-size: 0.875rem;
    }

    .tutorial-description {
        font-size: 0.78rem;
    }

    .tutorial-content {
        gap: 0.625rem;
        margin-bottom: 0.75rem;
    }

    .tutorial-text {
        padding-right: 0.5rem;
    }

    .tutorial-footer {
        padding-top: 0.625rem;
    }

    .tutorial-progress {
        font-size: 0.65rem;
    }

    .tutorial-next {
        font-size: 0.75rem;
    }
}

/* ═══════════════════════════════════════════════════════════════
   DARK MODE OVERRIDES
   ═══════════════════════════════════════════════════════════════ */
.dark .home-greeting { color: #f9fafb; }
.dark .home-tagline { color: #9ca3af; }

.dark .home-metric-card,
.dark .home-empty-state,
.dark .home-brand-focus,
.dark .home-cta-secondary {
    background: #15171f;
    border-color: #272a38;
}

.dark .home-brand-focus:hover {
    border-color: #3b3f54;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}

.dark .home-brand-focus-badge {
    background: #2b2210;
    color: #fbbf24;
}

.dark .home-metric-value,
.dark .home-brand-name {
    color: #f9fafb;
}

.dark .home-cta-secondary { color: #e5e7eb; }
.dark .home-cta-secondary:hover {
    background: #1c1f2a;
    border-color: #373b4d;
}

.dark .home-cta-ghost { color: #9ca3af; }
.dark .home-cta-ghost:hover {
    background: rgba(30, 32, 42, 0.5);
    color: #e5e7eb;
}

.dark .home-preview-card {
    background: #1e2029;
}

.dark .home-cta-primary .home-cta-icon {
    background: rgba(0, 0, 0, 0.2);
}

.dark .home-cta-secondary .home-cta-icon,
.dark .home-cta-ghost .home-cta-icon {
    background: #2b2210;
    color: #fbbf24;
}

.dark .home-brand-logo {
    background: #1e2029;
}


/* ═══════════════════════════════════════════════════════════════
   MOBILE MENU ARROW HINT
   ═══════════════════════════════════════════════════════════════ */

/* Only shown on mobile (component already guards via JS, CSS adds safety) */
@media (min-width: 768px) {
    .mobile-menu-arrow-hint { display: none !important; }
}

.mobile-menu-arrow-hint {
    position: fixed;
    /* Anchored just below and to the right of the top-left hamburger button
       (button is roughly 44px tall + header padding ~16px = top: ~60px) */
    top: 56px;
    left: 4px;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    pointer-events: none;
    animation: arrow-hint-entrance 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes arrow-hint-entrance {
    from { opacity: 0; transform: translateY(-8px) scale(0.85); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* Label */
.mobile-menu-arrow-label {
    background: #d97706;
    color: white;
    font-size: 0.72rem;
    font-weight: 700;
    padding: 0.3rem 0.65rem;
    border-radius: 999px;
    white-space: nowrap;
    box-shadow: 0 4px 16px rgba(217, 119, 6, 0.3);
    animation: arrow-label-pulse 2s ease-in-out infinite;
    letter-spacing: 0.01em;
    /* Shift label to the right so it doesn't go off-screen */
    margin-left: 8px;
}

@keyframes arrow-label-pulse {
    0%, 100% { box-shadow: 0 4px 16px rgba(217, 119, 6, 0.3); }
    50%       { box-shadow: 0 6px 24px rgba(180, 83, 9, 0.45); }
}

/* SVG Arrow */
.mobile-menu-arrow-svg {
    width: 40px;
    height: 54px;
    /* Arrow curves up-left toward the button */
    transform: scaleX(-1); /* mirror so it points toward the button at top-left */
    animation: arrow-bounce 1.4s ease-in-out infinite;
    margin-left: 4px;
}

@keyframes arrow-bounce {
    0%, 100% { transform: scaleX(-1) translateY(0); }
    50%       { transform: scaleX(-1) translateY(-5px); }
}

/* Dark mode overrides */
.dark .mobile-menu-arrow-label {
    box-shadow: 0 4px 20px rgba(217, 119, 6, 0.4);
}

/* ── Hero CTA (Big prominent button) ────────────────────────── */
.home-hero-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    width: 100%;
    padding: 1.125rem 2rem;
    border-radius: 1rem;
    border: none;
    cursor: pointer;
    font-size: 1.125rem;
    font-weight: 700;
    color: white;
    background: #d97706;
    box-shadow: 0 4px 16px rgba(217, 119, 6, 0.3);
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
}

.home-hero-cta:hover {
    background: #b45309;
    box-shadow: 0 6px 22px rgba(217, 119, 6, 0.4);
}

.home-hero-cta:active {
    box-shadow: 0 2px 8px rgba(217, 119, 6, 0.25);
}

/* ── Resume CTA (smaller, secondary) ────────────────────────── */
.home-resume-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    margin-top: 0.75rem;
    padding: 0.75rem 1.5rem;
    border-radius: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.12);
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.7);
    background: rgba(255, 255, 255, 0.06);
    backdrop-filter: blur(8px);
    transition: all 0.25s ease;
}

.home-resume-cta:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(59, 130, 246, 0.3);
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/home-tutorial.css"],"names":[],"mappings":"AAAA;;oEAEoE;;AAEpE,mEAAmE;AACnE;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA,mEAAmE;AACnE;IACI,aAAa;AACjB;;AAEA,mEAAmE;AACnE;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,WAAW,uBAAuB,EAAE;IACpC,MAAM,wBAAwB,EAAE;IAChC,MAAM,wBAAwB,EAAE;IAChC,MAAM,wBAAwB,EAAE;IAChC,MAAM,wBAAwB,EAAE;IAChC,MAAM,wBAAwB,EAAE;IAChC,MAAM,uBAAuB,EAAE;AACnC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE;IACI,aAAa;IACb,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,yCAAyC;IACzC,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,mEAAmE;AACnE;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,6EAA6E;IAC7E,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA,mEAAmE;AACnE;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;IACvB,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,eAAe;IACf,iEAAiE;AACrE;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;;oEAEoE;AACpE;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;IAChB;;IAEA,mBAAmB;IACnB;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA,kBAAkB;IAClB;QACI,qCAAqC;QACrC,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA,sBAAsB;IACtB;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA,sBAAsB;IACtB;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;;QAEI,aAAa;QACb,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA,eAAe;IACf;QACI,sBAAsB;QACtB,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA,uBAAuB;IACvB;QACI,qCAAqC;QACrC,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA,eAAe;IACf;QACI,YAAY;QACZ,aAAa;QACb,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;;AAGA;;oEAEoE;;AAEpE,mEAAmE;AACnE;IACI,YAAY;IACZ,6BAA6B;IAC7B,qCAAqC;IACrC,yCAAyC;IACzC,wCAAwC;IACxC,sBAAsB;IACtB,gBAAgB;IAChB;;qCAEiC;IACjC,iDAAiD;AACrD;;AAEA;IACI,WAAW,2BAA2B,EAAE;IACxC,MAAM,uCAAuC,EAAE;AACnD;;AAEA,mEAAmE;AACnE;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,wCAAwC;IACxC,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mEAAmE;AACnE;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;oEAEoE;AACpE;IACI;QACI,yBAAyB;QACzB,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,wDAAwD;QACxD,wEAAwE;IAC5E;;IAEA;QACI,WAAW,yCAAyC,EAAE;QACtD,MAAM,4CAA4C,EAAE;IACxD;;IAEA,sDAAsD;IACtD;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;;oEAEoE;AACpE,uBAAuB,cAAc,EAAE;AACvC,sBAAsB,cAAc,EAAE;;AAEtC;;;;IAII,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA,4BAA4B,cAAc,EAAE;AAC5C;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,wBAAwB,cAAc,EAAE;AACxC;IACI,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;;oEAEoE;;AAEpE,4EAA4E;AAC5E;IACI,0BAA0B,wBAAwB,EAAE;AACxD;;AAEA;IACI,eAAe;IACf;0EACsE;IACtE,SAAS;IACT,SAAS;IACT,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,oBAAoB;IACpB,0EAA0E;AAC9E;;AAEA;IACI,OAAO,UAAU,EAAE,uCAAuC,EAAE;IAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AAC1D;;AAEA,UAAU;AACV;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,6CAA6C;IAC7C,oDAAoD;IACpD,sBAAsB;IACtB,yDAAyD;IACzD,gBAAgB;AACpB;;AAEA;IACI,WAAW,6CAA6C,EAAE;IAC1D,YAAY,6CAA6C,EAAE;AAC/D;;AAEA,cAAc;AACd;IACI,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,qBAAqB,EAAE,sDAAsD;IAC7E,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA;IACI,WAAW,mCAAmC,EAAE;IAChD,YAAY,sCAAsC,EAAE;AACxD;;AAEA,wBAAwB;AACxB;IACI,6CAA6C;AACjD;;AAEA,kEAAkE;AAClE;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,6CAA6C;IAC7C,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA,kEAAkE;AAClE;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,2CAA2C;IAC3C,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;IAC/B,qCAAqC;IACrC,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,YAAY;AAChB","sourcesContent":["/* ═══════════════════════════════════════════════════════════════\n   HOME PAGE STYLES\n   ═══════════════════════════════════════════════════════════════ */\n\n/* ── Page Container ──────────────────────────────────────────── */\n.home-page {\n    position: relative;\n    min-height: 100dvh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 2rem 1.5rem 4rem;\n    background: #fafaf9;\n}\n\n.dark .home-page {\n    background: hsl(228, 14%, 6%);\n}\n\n\n.home-container {\n    position: relative;\n    z-index: 1;\n    max-width: 480px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 1.75rem;\n}\n\n/* ── Floating Orbs (Disabled) ────────────────────────────────── */\n.home-orb {\n    display: none;\n}\n\n/* ── Hero Greeting ───────────────────────────────────────────── */\n.home-hero {\n    text-align: center;\n    padding-top: 1rem;\n}\n\n.home-greeting {\n    font-size: 1.75rem;\n    font-weight: 800;\n    color: #111827;\n    line-height: 1.2;\n    margin-bottom: 0.5rem;\n    letter-spacing: -0.02em;\n}\n\n.home-wave {\n    display: inline-block;\n    animation: home-wave-anim 2s ease-in-out infinite;\n    transform-origin: 70% 70%;\n}\n\n@keyframes home-wave-anim {\n    0%, 100% { transform: rotate(0deg); }\n    10% { transform: rotate(14deg); }\n    20% { transform: rotate(-8deg); }\n    30% { transform: rotate(14deg); }\n    40% { transform: rotate(-4deg); }\n    50% { transform: rotate(10deg); }\n    60% { transform: rotate(0deg); }\n}\n\n.home-tagline {\n    font-size: 0.95rem;\n    color: #6b7280;\n    max-width: 320px;\n    margin: 0 auto;\n    line-height: 1.5;\n}\n\n/* ── Metric Cards ────────────────────────────────────────────── */\n.home-metrics {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.75rem;\n}\n\n.home-metric-card {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 1rem;\n    padding: 1rem 0.75rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n    text-align: center;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.home-metric-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.home-metric-icon {\n    width: 2.25rem;\n    height: 2.25rem;\n    border-radius: 0.75rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.home-metric-pink {\n    background: #fef3c7;\n    color: #b45309;\n}\n\n.home-metric-orange {\n    background: #ffedd5;\n    color: #c2410c;\n}\n\n.home-metric-purple {\n    background: #f3f4f6;\n    color: #4b5563;\n}\n\n.home-metric-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.125rem;\n}\n\n.home-metric-value {\n    font-size: 1.5rem;\n    font-weight: 800;\n    color: #111827;\n    line-height: 1;\n}\n\n.home-metric-label {\n    font-size: 0.65rem;\n    color: #9ca3af;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n/* ── Empty State ─────────────────────────────────────────────── */\n.home-empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 2rem 1.5rem;\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 1.25rem;\n}\n\n.home-empty-icon {\n    width: 3.5rem;\n    height: 3.5rem;\n    border-radius: 1rem;\n    background: #fef3c7;\n    color: #b45309;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1rem;\n}\n\n.home-empty-text {\n    font-size: 0.9rem;\n    color: #6b7280;\n    line-height: 1.6;\n    max-width: 300px;\n}\n\n/* ── Brand Focus Card ────────────────────────────────────────── */\n.home-brand-focus {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 1.25rem;\n    padding: 1rem 1.25rem;\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n    text-align: left;\n    overflow: hidden;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.home-brand-focus:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    border-color: #d1d5db;\n}\n\n.home-brand-focus-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    font-size: 0.65rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #b45309;\n    background: #fef3c7;\n    padding: 0.25rem 0.75rem;\n    border-radius: 999px;\n    margin-bottom: 0.75rem;\n    width: fit-content;\n}\n\n.home-brand-focus-content {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    min-width: 0;\n    overflow: hidden;\n}\n\n.home-brand-logo {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 0.75rem;\n    object-fit: cover;\n    flex-shrink: 0;\n    background: #f3f4f6;\n}\n\n.home-brand-logo-placeholder {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 0.75rem;\n    background: #d97706;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.25rem;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.home-brand-focus-info {\n    flex: 1;\n    min-width: 0;\n}\n\n.home-brand-name {\n    font-size: 1rem;\n    font-weight: 700;\n    color: #111827;\n    margin-bottom: 0.125rem;\n}\n\n.home-brand-desc {\n    font-size: 0.75rem;\n    color: #9ca3af;\n    line-height: 1.4;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    text-overflow: ellipsis;\n    word-break: break-word;\n}\n\n/* ── CTA Buttons ─────────────────────────────────────────────── */\n.home-ctas {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.home-cta {\n    display: flex;\n    align-items: center;\n    gap: 0.875rem;\n    width: 100%;\n    padding: 1rem 1.25rem;\n    border-radius: 1rem;\n    border: none;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    text-align: left;\n}\n\n.home-cta-primary {\n    background: #d97706;\n    color: white;\n    box-shadow: 0 2px 10px rgba(217, 119, 6, 0.25);\n}\n\n.home-cta-primary:hover {\n    background: #b45309;\n    box-shadow: 0 4px 16px rgba(217, 119, 6, 0.35);\n}\n\n.home-cta-secondary {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    color: #374151;\n}\n\n.home-cta-secondary:hover {\n    background: #f9fafb;\n    border-color: #d1d5db;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.home-cta-ghost {\n    background: transparent;\n    border: 1px dashed rgba(217, 119, 6, 0.28);\n    color: #6b7280;\n}\n\n.home-cta-ghost:hover {\n    background: rgba(255, 255, 255, 0.5);\n    border-color: rgba(217, 119, 6, 0.4);\n    color: #374151;\n}\n\n.home-cta-icon {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 0.75rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.home-cta-primary .home-cta-icon {\n    background: rgba(255, 255, 255, 0.2);\n}\n\n.home-cta-secondary .home-cta-icon,\n.home-cta-ghost .home-cta-icon {\n    background: #fef3c7;\n    color: #b45309;\n}\n\n.home-cta-text {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.125rem;\n}\n\n.home-cta-label {\n    font-size: 0.95rem;\n    font-weight: 650;\n    line-height: 1.3;\n}\n\n.home-cta-sublabel {\n    font-size: 0.75rem;\n    opacity: 0.7;\n    line-height: 1.3;\n}\n\n/* ── Product Preview ─────────────────────────────────────────── */\n.home-preview-section {\n    margin-top: 0.5rem;\n}\n\n.home-preview-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.75rem;\n}\n\n.home-preview-title {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.home-preview-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 0.5rem;\n}\n\n.home-preview-card {\n    position: relative;\n    aspect-ratio: 3 / 4;\n    border-radius: 0.75rem;\n    overflow: hidden;\n    background: #f3f4f6;\n}\n\n.home-preview-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.home-preview-overlay {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 0.5rem;\n    background: linear-gradient(to top, rgba(0,0,0,0.6), transparent);\n}\n\n.home-preview-price {\n    font-size: 0.7rem;\n    font-weight: 700;\n    color: white;\n}\n\n\n/* ═══════════════════════════════════════════════════════════════\n   MOBILE RESPONSIVENESS — HOME PAGE\n   ═══════════════════════════════════════════════════════════════ */\n@media (max-width: 767px) {\n    .home-page {\n        padding: 1.25rem 1rem 3rem;\n    }\n\n    .home-container {\n        gap: 1.25rem;\n    }\n\n    /* ── Greeting ── */\n    .home-greeting {\n        font-size: 1.4rem;\n    }\n\n    .home-tagline {\n        font-size: 0.85rem;\n        max-width: 280px;\n    }\n\n    /* ── Metrics ── */\n    .home-metrics {\n        grid-template-columns: repeat(3, 1fr);\n        gap: 0.5rem;\n    }\n\n    .home-metric-card {\n        padding: 0.75rem 0.5rem;\n        border-radius: 0.75rem;\n    }\n\n    .home-metric-icon {\n        width: 2rem;\n        height: 2rem;\n        border-radius: 0.5rem;\n    }\n\n    .home-metric-icon svg {\n        width: 1rem;\n        height: 1rem;\n    }\n\n    .home-metric-value {\n        font-size: 1.25rem;\n    }\n\n    .home-metric-label {\n        font-size: 0.55rem;\n        letter-spacing: 0.02em;\n    }\n\n    /* ── Empty State ── */\n    .home-empty-state {\n        padding: 1.5rem 1rem;\n    }\n\n    .home-empty-icon {\n        width: 3rem;\n        height: 3rem;\n    }\n\n    .home-empty-text {\n        font-size: 0.82rem;\n    }\n\n    /* ── Brand Focus ── */\n    .home-brand-focus {\n        padding: 0.875rem 1rem;\n        border-radius: 1rem;\n    }\n\n    .home-brand-logo,\n    .home-brand-logo-placeholder {\n        width: 2.5rem;\n        height: 2.5rem;\n        border-radius: 0.625rem;\n    }\n\n    .home-brand-logo-placeholder {\n        font-size: 1rem;\n    }\n\n    .home-brand-name {\n        font-size: 0.9rem;\n    }\n\n    .home-brand-desc {\n        font-size: 0.7rem;\n    }\n\n    /* ── CTAs ── */\n    .home-cta {\n        padding: 0.875rem 1rem;\n        gap: 0.75rem;\n        border-radius: 0.875rem;\n    }\n\n    .home-cta-icon {\n        width: 2.25rem;\n        height: 2.25rem;\n        border-radius: 0.625rem;\n    }\n\n    .home-cta-icon svg {\n        width: 1.125rem;\n        height: 1.125rem;\n    }\n\n    .home-cta-label {\n        font-size: 0.875rem;\n    }\n\n    .home-cta-sublabel {\n        font-size: 0.7rem;\n    }\n\n    /* ── Preview Grid ── */\n    .home-preview-grid {\n        grid-template-columns: repeat(4, 1fr);\n        gap: 0.375rem;\n    }\n\n    .home-preview-card {\n        border-radius: 0.5rem;\n    }\n\n    .home-preview-price {\n        font-size: 0.6rem;\n    }\n\n    .home-preview-overlay {\n        padding: 0.35rem;\n    }\n\n    /* ── Orbs ── */\n    .home-orb-1 {\n        width: 160px;\n        height: 160px;\n        top: -40px;\n        right: -50px;\n    }\n\n    .home-orb-2 {\n        width: 120px;\n        height: 120px;\n    }\n\n    .home-orb-3 {\n        width: 100px;\n        height: 100px;\n    }\n}\n\n\n/* ═══════════════════════════════════════════════════════════════\n   TUTORIAL OVERLAY STYLES\n   ═══════════════════════════════════════════════════════════════ */\n\n/* ── Bubble ──────────────────────────────────────────────────── */\n.tutorial-bubble {\n    width: 320px;\n    max-width: calc(100vw - 2rem);\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(20px) saturate(1.4);\n    border: 1px solid rgba(217, 119, 6, 0.2);\n    border-radius: 1.25rem;\n    padding: 1.25rem;\n    box-shadow:\n        0 8px 32px rgba(217, 119, 6, 0.15),\n        0 2px 8px rgba(0, 0, 0, 0.04);\n    animation: tutorial-float 3s ease-in-out infinite;\n}\n\n@keyframes tutorial-float {\n    0%, 100% { transform: translateY(-50%); }\n    50% { transform: translateY(calc(-50% - 6px)); }\n}\n\n/* ── Caret ───────────────────────────────────────────────────── */\n.tutorial-caret {\n    position: absolute;\n    width: 12px;\n    height: 12px;\n    background: rgba(255, 255, 255, 0.95);\n    border: 1px solid rgba(217, 119, 6, 0.2);\n    transform: rotate(45deg);\n}\n\n.tutorial-caret-left {\n    left: -7px;\n    top: 50%;\n    margin-top: -6px;\n    border-right: none;\n    border-top: none;\n}\n\n/* ── Close Button ────────────────────────────────────────────── */\n.tutorial-close {\n    position: absolute;\n    top: 0.75rem;\n    right: 0.75rem;\n    width: 1.75rem;\n    height: 1.75rem;\n    border-radius: 50%;\n    border: none;\n    background: #f3f4f6;\n    color: #9ca3af;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background 0.2s, color 0.2s;\n}\n\n.tutorial-close:hover {\n    background: #e5e7eb;\n    color: #374151;\n}\n\n/* ── Content ─────────────────────────────────────────────────── */\n.tutorial-content {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n}\n\n.tutorial-icon-wrapper {\n    width: 2.25rem;\n    height: 2.25rem;\n    border-radius: 0.625rem;\n    background: #fef3c7;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.tutorial-text {\n    flex: 1;\n    min-width: 0;\n    padding-right: 1rem;\n}\n\n.tutorial-title {\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: #111827;\n    margin-bottom: 0.25rem;\n}\n\n.tutorial-description {\n    font-size: 0.82rem;\n    color: #6b7280;\n    line-height: 1.5;\n}\n\n/* ── Footer ──────────────────────────────────────────────────── */\n.tutorial-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 0.75rem;\n    border-top: 1px solid rgba(217, 119, 6, 0.12);\n}\n\n.tutorial-progress {\n    font-size: 0.7rem;\n    color: #9ca3af;\n    font-weight: 500;\n}\n\n.tutorial-dots {\n    display: flex;\n    gap: 0.35rem;\n}\n\n.tutorial-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #e5e7eb;\n    transition: all 0.3s ease;\n}\n\n.tutorial-dot-active {\n    background: #d97706;\n    width: 16px;\n    border-radius: 3px;\n}\n\n.tutorial-next {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #b45309;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0.25rem 0.5rem;\n    border-radius: 0.5rem;\n    transition: background 0.2s;\n}\n\n.tutorial-next:hover {\n    background: #fef3c7;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   MOBILE RESPONSIVENESS — TUTORIAL\n   ═══════════════════════════════════════════════════════════════ */\n@media (max-width: 767px) {\n    .tutorial-bubble {\n        width: calc(100vw - 2rem);\n        max-width: 360px;\n        padding: 1rem;\n        border-radius: 1rem;\n        animation: tutorial-float-mobile 3s ease-in-out infinite;\n        /* On mobile the bubble sits at the bottom, no translateY(-50%) needed */\n    }\n\n    @keyframes tutorial-float-mobile {\n        0%, 100% { transform: translateX(-50%) translateY(0); }\n        50% { transform: translateX(-50%) translateY(-6px); }\n    }\n\n    /* Hide caret on mobile since sidebar is not visible */\n    .tutorial-caret {\n        display: none;\n    }\n\n    .tutorial-icon-wrapper {\n        width: 2rem;\n        height: 2rem;\n        border-radius: 0.5rem;\n    }\n\n    .tutorial-icon-wrapper svg {\n        width: 1rem;\n        height: 1rem;\n    }\n\n    .tutorial-title {\n        font-size: 0.875rem;\n    }\n\n    .tutorial-description {\n        font-size: 0.78rem;\n    }\n\n    .tutorial-content {\n        gap: 0.625rem;\n        margin-bottom: 0.75rem;\n    }\n\n    .tutorial-text {\n        padding-right: 0.5rem;\n    }\n\n    .tutorial-footer {\n        padding-top: 0.625rem;\n    }\n\n    .tutorial-progress {\n        font-size: 0.65rem;\n    }\n\n    .tutorial-next {\n        font-size: 0.75rem;\n    }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   DARK MODE OVERRIDES\n   ═══════════════════════════════════════════════════════════════ */\n.dark .home-greeting { color: #f9fafb; }\n.dark .home-tagline { color: #9ca3af; }\n\n.dark .home-metric-card,\n.dark .home-empty-state,\n.dark .home-brand-focus,\n.dark .home-cta-secondary {\n    background: #15171f;\n    border-color: #272a38;\n}\n\n.dark .home-brand-focus:hover {\n    border-color: #3b3f54;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n}\n\n.dark .home-brand-focus-badge {\n    background: #2b2210;\n    color: #fbbf24;\n}\n\n.dark .home-metric-value,\n.dark .home-brand-name {\n    color: #f9fafb;\n}\n\n.dark .home-cta-secondary { color: #e5e7eb; }\n.dark .home-cta-secondary:hover {\n    background: #1c1f2a;\n    border-color: #373b4d;\n}\n\n.dark .home-cta-ghost { color: #9ca3af; }\n.dark .home-cta-ghost:hover {\n    background: rgba(30, 32, 42, 0.5);\n    color: #e5e7eb;\n}\n\n.dark .home-preview-card {\n    background: #1e2029;\n}\n\n.dark .home-cta-primary .home-cta-icon {\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.dark .home-cta-secondary .home-cta-icon,\n.dark .home-cta-ghost .home-cta-icon {\n    background: #2b2210;\n    color: #fbbf24;\n}\n\n.dark .home-brand-logo {\n    background: #1e2029;\n}\n\n\n/* ═══════════════════════════════════════════════════════════════\n   MOBILE MENU ARROW HINT\n   ═══════════════════════════════════════════════════════════════ */\n\n/* Only shown on mobile (component already guards via JS, CSS adds safety) */\n@media (min-width: 768px) {\n    .mobile-menu-arrow-hint { display: none !important; }\n}\n\n.mobile-menu-arrow-hint {\n    position: fixed;\n    /* Anchored just below and to the right of the top-left hamburger button\n       (button is roughly 44px tall + header padding ~16px = top: ~60px) */\n    top: 56px;\n    left: 4px;\n    z-index: 10000;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n    pointer-events: none;\n    animation: arrow-hint-entrance 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n\n@keyframes arrow-hint-entrance {\n    from { opacity: 0; transform: translateY(-8px) scale(0.85); }\n    to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* Label */\n.mobile-menu-arrow-label {\n    background: #d97706;\n    color: white;\n    font-size: 0.72rem;\n    font-weight: 700;\n    padding: 0.3rem 0.65rem;\n    border-radius: 999px;\n    white-space: nowrap;\n    box-shadow: 0 4px 16px rgba(217, 119, 6, 0.3);\n    animation: arrow-label-pulse 2s ease-in-out infinite;\n    letter-spacing: 0.01em;\n    /* Shift label to the right so it doesn't go off-screen */\n    margin-left: 8px;\n}\n\n@keyframes arrow-label-pulse {\n    0%, 100% { box-shadow: 0 4px 16px rgba(217, 119, 6, 0.3); }\n    50%       { box-shadow: 0 6px 24px rgba(180, 83, 9, 0.45); }\n}\n\n/* SVG Arrow */\n.mobile-menu-arrow-svg {\n    width: 40px;\n    height: 54px;\n    /* Arrow curves up-left toward the button */\n    transform: scaleX(-1); /* mirror so it points toward the button at top-left */\n    animation: arrow-bounce 1.4s ease-in-out infinite;\n    margin-left: 4px;\n}\n\n@keyframes arrow-bounce {\n    0%, 100% { transform: scaleX(-1) translateY(0); }\n    50%       { transform: scaleX(-1) translateY(-5px); }\n}\n\n/* Dark mode overrides */\n.dark .mobile-menu-arrow-label {\n    box-shadow: 0 4px 20px rgba(217, 119, 6, 0.4);\n}\n\n/* ── Hero CTA (Big prominent button) ────────────────────────── */\n.home-hero-cta {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    width: 100%;\n    padding: 1.125rem 2rem;\n    border-radius: 1rem;\n    border: none;\n    cursor: pointer;\n    font-size: 1.125rem;\n    font-weight: 700;\n    color: white;\n    background: #d97706;\n    box-shadow: 0 4px 16px rgba(217, 119, 6, 0.3);\n    transition: all 0.2s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n.home-hero-cta:hover {\n    background: #b45309;\n    box-shadow: 0 6px 22px rgba(217, 119, 6, 0.4);\n}\n\n.home-hero-cta:active {\n    box-shadow: 0 2px 8px rgba(217, 119, 6, 0.25);\n}\n\n/* ── Resume CTA (smaller, secondary) ────────────────────────── */\n.home-resume-cta {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    width: 100%;\n    margin-top: 0.75rem;\n    padding: 0.75rem 1.5rem;\n    border-radius: 0.75rem;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    cursor: pointer;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.7);\n    background: rgba(255, 255, 255, 0.06);\n    backdrop-filter: blur(8px);\n    transition: all 0.25s ease;\n}\n\n.home-resume-cta:hover {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(59, 130, 246, 0.3);\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
